import { privateInstance } from "../configs";

export const taxeApi = {
  async getTaxePayments() {
    const res = await privateInstance.get("/taxes/api/payment/");
    return res.data;
  },
  async retrieveTaxePayment(id) {
    const res = await privateInstance.get(`/taxes/api/payment/${id}/`);
    return res.data;
  },
  async postTaxePayment(payment) {
    const res = await privateInstance.post(`/taxes/api/payment/`, payment);
    return res.data;
  },
  async putTaxePayment(id, payment) {
    const res = await privateInstance.put(`/taxes/api/payment/${id}/`, payment);
    return res.data;
  },
  async deleteTaxePayment(id) {
    const res = await privateInstance.delete(`/taxes/api/payment/${id}/`);
    return res.data;
  },
  async getMevReports() {
    const res = await privateInstance.get("/taxes/api/report/");
    return res.data;
  },
  async retrieveMevReport(id) {
    const res = await privateInstance.get(`/taxes/api/report/${id}/`);
    return res.data;
  },
  async postMevReport(report) {
    const res = await privateInstance.post(`/taxes/api/report/`, report);
    return res.data;
  },
  async putMevReport(id, report) {
    const res = await privateInstance.put(`/taxes/api/report/${id}/`, report);
    return res.data;
  },
  async deleteMevReport(id) {
    const res = await privateInstance.delete(`/taxes/api/report/${id}/`);
    return res.data;
  },
  async getTaxeSummary(start, end) {
    const res = await privateInstance.get(
      `analytics/api/taxes?start=${start}&end=${end}/`
    );
    return res.data;
  }
};
